import React from 'react';
import { useLocation } from 'react-router-dom';

import { Box, Grid2, Typography } from '@mui/material';

import { Tab } from 'pages/Profile';
import { Button } from 'shared';
import { getDomainAndSubdomain } from 'utils/domain';

interface ProfileTabsProps {
  tabs: Tab[];
  onTabChange?: (path: string) => void;
}

const ProfileTabs: React.FC<ProfileTabsProps> = ({ tabs, onTabChange }) => {
  const { pathname } = useLocation();
  const { subdomain } = getDomainAndSubdomain();
  const isPoolsPageAvailable =
    subdomain !== 'cryptohall24-duerr' &&
    subdomain !== 'cryptohall24-quetta' &&
    subdomain !== 'pantheon' &&
    subdomain !== 'pantheon-aus' &&
    subdomain !== 'hearst' &&
    subdomain !== 'avatron' &&
    subdomain !== 'paymine' &&
    subdomain !== 'amityage' &&
    subdomain !== 'cryptotech' &&
    subdomain !== 'higgs';

  const visibleTabs = isPoolsPageAvailable ? tabs.filter(({ path }) => path !== 'pools') : tabs;

  // Find the active tab based on the pathname
  const activeTab = tabs.find(({ path }) => pathname.includes(path));

  return (
    <Box mt={6} data-testid='profile-header'>
      <Grid2 container>
        <Grid2 size={{ xs: 12, md: 4 }} sx={{ display: { xs: 'none', sm: 'block' } }}>
          <Typography variant='h2'>{activeTab && activeTab.label}</Typography>
        </Grid2>

        {visibleTabs && (
          <Grid2 size={{ xs: 12, md: 8 }}>
            <Box display='flex' justifyContent='flex-end' pb={4}>
              {visibleTabs.map(({ label, path }, index) => {
                const isActive = activeTab && pathname.includes(path);
                return (
                  <Button
                    key={label + index}
                    disabled={isActive} // Disable the button if it's the active tab
                    label={label}
                    onClick={() => onTabChange?.(path)}
                    testId={`profile-header-${path}`}
                    style={{ marginLeft: 16 }} // spacing between buttons
                  />
                );
              })}
            </Box>
          </Grid2>
        )}
      </Grid2>
    </Box>
  );
};

export default ProfileTabs;
